import { createContext } from 'react'

const DataLifeCycleContext = createContext()

export default DataLifeCycleContext
